import PlanEntry from '../../models/PlanEntry'

export const START_LOAD_PLAN_ENTRIES = 'START_LOAD_PLAN_ENTRIES'
export const LOAD_PLAN_ENTRIES_SUCCESS = 'LOAD_PLAN_ENTRIES_SUCCESS'
export const LOAD_PLAN_ENTRIES_FAIL = 'LOAD_PLAN_ENTRIES_FAIL'
export const LAYOUT_CHANGE = 'LAYOUT_CHANGE'
export const ADD_FILTER = 'ADD_FILTER'
export const REMOVE_FILTER = 'REMOVE_FILTER'
export const SET_INITIAL_FILTERS = 'SET_INITIAL_FILTERS'
export const CHANGE_ORDER = 'CHANGE_ORDER'
export const CLEAR_FILTER = 'CLEAR_FILTER'
export const ENTRY_ADDED_TO_PLAYLIST = 'ENTRY_ADDED_TO_PLAYLIST'
export const CHANGE_FILTER_URL = 'CHANGE_FILTER_URL'
export const FEATURE_PLAN_ENTRY = 'FEATURE_PLAN_ENTRY'
export const UNFEATURE_PLAN_ENTRY = 'UNFEATURE_PLAN_ENTRY'
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS'
export const CLEAR_PLAN_ENTRIES = 'CLEAR_PLAN_ENTRIES'
export const DEFAULT_FILTERS = 'DEFAULT_FILTERS'
export const ADD_CUSTOM_DURATION_FILTER = 'ADD_CUSTOM_DURATION_FILTER'

export function changeLayout(layout) {
  return {
    type: LAYOUT_CHANGE,
    layout: layout
  }
}

export function featurePlanEntry(planEntryId) {
  return {
    type: FEATURE_PLAN_ENTRY,
    id: planEntryId
  }
}

export function startLoadPlanEntries() {
  return {
    type: START_LOAD_PLAN_ENTRIES
  }
}

export function unfeaturePlanEntry(planEntryId) {
  return {
    type: UNFEATURE_PLAN_ENTRY,
    id: planEntryId
  }
}

export function addFilter(filterSection, filter, options) {
  return {
    type: ADD_FILTER,
    filterSection,
    filter,
    options
  }
}

export function addCustomDurationFilter({ min, max }) {
  return {
    type: ADD_CUSTOM_DURATION_FILTER,
    min,
    max
  }
}

export function applyDurationFilter({ durationOptions, isFromClassFinderPage }) {
  return (dispatch, getState) => {
    let {
      ui: {
        planEntries: {
          customDuration: { min, max }
        }
      }
    } = getState()
    if (min == null) {
      min = 0
    }
    if (min != null && max != null && max < min) {
      const temp = min
      min = max
      max = temp
    }
    const preDefinedDurations = durationOptions.reduce((acc, duration) => {
      return [`${duration.min}-${duration.max}`, ...acc]
    }, [])
    dispatch(addFilter('custom_duration', { min, max, preDefinedDurations }))
    dispatch(addCustomDurationFilter({ min, max }))
    if (isFromClassFinderPage) {
      dispatch(clearPlanEntries())
      dispatch(loadPlanEntries())
    }
  }
}

export function removeFilter(filterSection, filter, filterByField, options) {
  return {
    type: REMOVE_FILTER,
    filterSection,
    filter,
    filterByField,
    options
  }
}

export function clearFilter(label) {
  return {
    type: CLEAR_FILTER,
    label
  }
}

export function clearAllFilters() {
  return {
    type: CLEAR_ALL_FILTERS
  }
}

export function setDefaultFilter(defaultFilter) {
  return {
    type: DEFAULT_FILTERS,
    defaultFilter
  }
}

export function changeOrder(order) {
  return {
    type: CHANGE_ORDER,
    order
  }
}

export function setInitialFilters(initialFilters) {
  return {
    type: SET_INITIAL_FILTERS,
    initialFilters
  }
}

export function clearPlanEntries(params) {
  return {
    type: CLEAR_PLAN_ENTRIES,
    params
  }
}

export function loadPlanEntriesSuccess(planEntries, totalPlanEntries) {
  return {
    type: LOAD_PLAN_ENTRIES_SUCCESS,
    planEntries,
    totalPlanEntries
  }
}

export function changeFilterUrl(filters) {
  return {
    type: CHANGE_FILTER_URL,
    filters
  }
}

export function loadPlanEntries(callback) {
  return (dispatch, getState) => {
    dispatch(startLoadPlanEntries())

    const state = getState()
    const planEntriesState = state.ui.planEntries
    let {
      defaultFilter = {},
      filtered,
      order,
      grid: { page }
    } = planEntriesState

    const filters = { ...getRequestObject(filtered), ...defaultFilter }
    const requestParams = {
      ...filters,
      order,
      per_page: 24,
      page
    }

    PlanEntry.findAll(requestParams)
      .then((res) => res)
      .then((response) => {
        dispatch(loadPlanEntriesSuccess(response.data, response.headers.total))
        dispatch(changeFilterUrl(requestParams))
        if (callback) callback()

        // Google Tag Manager
        if (window.dataLayer) {
          const plansLoaded = window.dataLayer.find((elem) => {
            return elem.event === 'plansLoaded'
          })

          if (!plansLoaded) {
            let planIds = []

            for (let i = 0; i < response.data.length; i++) {
              const entry = response.data[i]
              if (entry.plan && entry.plan.id) {
                planIds.push('plan_' + entry.plan.id)
              }
              if (planIds.length >= 5) break
            }

            window.dataLayer.push({
              event: 'plansLoaded',
              planIds: planIds
            })
          }
        }
      })
  }
}

const getRequestObject = (filterOptions) => {
  return {
    instructors: extractFilterAttribute(filterOptions.instructors, 'slug'),
    styles: extractCategorySlugs(filterOptions.styles).concat(
      filterOptions?.yoga?.length > 0
        ? extractFilterAttribute(filterOptions?.yoga, 'slug')
        : [],
      filterOptions?.fitness?.length > 0
        ? extractFilterAttribute(filterOptions?.fitness, 'slug')
        : [],
      filterOptions?.mindfulness?.length > 0
        ? extractFilterAttribute(filterOptions?.mindfulness, 'slug')
        : [],
      filterOptions?.wellness?.length > 0
        ? extractFilterAttribute(filterOptions?.wellness, 'slug')
        : [],
      filterOptions?.skills?.length > 0
        ? extractFilterAttribute(filterOptions?.skills, 'slug')
        : []
    ),
    difficulties: filterOptions.difficulties,
    equipments: filterOptions.equipment,
    focus_areas: filterOptions.focus_area,
    excludeCompleted: filterOptions.excludeCompleted,
    intensities: extractFilterAttribute(filterOptions.intensities, 'level'),
    duration: filterOptions.duration
  }
}

const extractCategorySlugs = (filteredCategories) => {
  const filtered = []
  for (const category in filteredCategories) {
    const filteredSubcategories =
      filteredCategories[category].filteredSubcategories || []
    if (filteredSubcategories === 'all') {
      filtered.push(category)
    } else {
      filteredSubcategories.forEach((subcategory) => {
        filtered.push(subcategory.slug)
      })
    }
  }
  return filtered
}

const extractFilterAttribute = (filteredObject, filterByField) =>
  filteredObject?.map((filter) => {
    if (typeof filter === 'object') {
      return filter[filterByField]
    } else {
      return filter
    }
  })
